import http from '@/plugins/axios/axios';

export default class ControlePontoService {

    //========================
    buscarPontoDuplicado(requisicao) {
        return http.post('/api/ponto-duplicado/analisar', requisicao);
    }
    buscarQuantidadeFuncionarios(requisicao) {
        return http.post('/api/ponto-duplicado/buscar-quatidade-funcionarios', requisicao);
    }
    buscarPontoDuplicadoMarcacoes(requisicao) {
        return http.post('/api/ponto-duplicado/buscar-ponto-marcacaoes', requisicao);
    }
    resolverPontoDuplicado(requisicao) {
        return http.post('/api/ponto-duplicado/resolver-ponto-duplicado', requisicao);
    }
    //=============================

    calcularPeriodoEditado(requisicao) {       
        return http.post('/api/controle-ponto/calcular-periodo-editado', requisicao);
    }

    calcularPeriodoEditado2(requisicao, param) {       
        let p = '';
        if(param) {
            p = '?' + param;
        }
        return http.post('/api/controle-ponto/calcular-periodo-editado2'+p, requisicao);
    }

    atualizarPeriodoEditado(requisicao) {       
        return http.post('/api/controle-ponto/atualizar-periodo-editado', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/controle-ponto/buscar-calcular-ponto', requisicao);
    }

    buscarCalcularMarcacoesFuncionario(requisicao) {       
        return http.post('/api/controle-ponto/buscar-calcular-marcacoes-funcionario', requisicao);
    }

    buscarResumoFuncionario(requisicao) {
        return http.post('/api/controle-ponto/buscar-resumo-funcionario', requisicao);
    }   

    buscarPontoMarcacoes(requisicao) {       
        return http.post('/api/controle-mover-marcacao/buscar-ponto-marcacaoes', requisicao);
    }

    moverMarcacoes(requisicao) {       
        return http.post('/api/controle-mover-marcacao/salvar', requisicao);
    }

    listarEventos(requisicao) {       
        return http.post('/api/evento-justificativa/listar-eventos', requisicao);
    }

    salvarEventosJustificativas(requisicao) {       
        return http.post('/api/evento-justificativa/salvar', requisicao);
    }

    salvarEventoJustificativaPendente(requisicao) {       
        return http.post('/api/evento-justificativa/salvar-pendente', requisicao);
    }

    buscarMudancaHorario(requisicao) {       
        return http.post('/api/mudanca-horario/controle-buscar', requisicao);
    }

    salvaMudancaHorario(requisicao) {       
        return http.post('/api/mudanca-horario/controle-salvar', requisicao);
    }

    excluirMudancaHorario(requisicao) {       
        return http.post('/api/mudanca-horario/controle-excluir', requisicao);
    }

    listarEventosAbonos(requisicao) {       
        return http.post('/api/ajuste-parcial/buscar', requisicao);
    }

    salvarAjusteParcial(requisicao) {       
        return http.post('/api/ajuste-parcial/salvar', requisicao);
    }

    alterarAjusteParcial(requisicao) {       
        return http.post('/api/ajuste-parcial/alterar', requisicao);
    }

    excluirAjusteParcial(requisicao) {       
        return http.post('/api/ajuste-parcial/excluir', requisicao);
    }

    listarMarcacoesEditar(requisicao) {       
        return http.post('/api/edicao-marcacoes/listar', requisicao);
    }

    salvarMarcacoesEditar(requisicao) {       
        return http.post('/api/edicao-marcacoes/salvar', requisicao);
    }

    marcarOcorrenciaExcluir(requisicao) {       
        return http.post('/api/ocorrencia/marcar-excluir', requisicao);
    }

    fecharPeriodo(requisicao) {       
        return http.post('/api/controle-ponto/concluir-fechar-periodo', requisicao);
    }

    abrirPeriodo(requisicao) {       
        return http.post('/api/controle-ponto/abrir-periodo', requisicao);
    }
    
    espelhoPonto(requisicao) {       
        return http.post('/api/solicitacao-documento?origem=controlePonto', requisicao);
       // return http.post('/api/relatorio/espelho-ponto/pdf', requisicao, {responseType: 'blob'});
    }

    buscarFeriadoExcluido(requisicao) {       
        return http.post('/api/feriado-excluido/buscar-feriado', requisicao);
    }

    salvarFeriadoExcluido(requisicao) {       
        return http.post('/api/feriado-excluido/salvar', requisicao);
    }

    buscarFolgaPontoDia(requisicao) {       
        return http.post('/api/folga/buscar-folga-ponto-dia', requisicao);
    }

    lancarFolgaPontoDia(requisicao) {       
        return http.post('/api/folga/lancar-folga-ponto-dia', requisicao);
    }

    excluirFolgaPontoDia(requisicao) {       
        return http.post('/api/folga/excluir-folga-ponto-dia', requisicao);
    }

    resolverFolgaPontoDiaNovoPendente(requisicao) {       
        return http.post('/api/folga/resolver-folga-ponto-dia-novo-pendente', requisicao);
    }

    resolverFolgaPontoDiaExcluirPendente(requisicao) {       
        return http.post('/api/folga/resolver-folga-ponto-dia-excluir-pendente', requisicao);
    }

    resolverExcluirMudancaHorarioPendente(requisicao) {       
        return http.post('/api/mudanca-horario/resolver-pendencia-controle-excluir', requisicao);
    }

    resolverNovoMudancaHorarioPendente(requisicao) {       
        return http.post('/api/mudanca-horario/resolver-pendencia-controle-salvar', requisicao);
    }

    resolverMarcarOcorrenciaExcluirPendente(requisicao) {       
        return http.post('/api/ocorrencia/resolver-pedencia-marcar-excluir', requisicao);
    }

    buscarItemSolicitacaoJustificarEvento(requisicao) {
        return http.post('/api/evento-justificativa/buscar-item-solicitacao', requisicao);
    }

    buscarItemSolicitacaoAjusteParcial(requisicao) {       
        return http.post('/api/ajuste-parcial/buscar-item-solicitacao', requisicao);
    }

    resolverPendenciaAjusteParcialNovo(requisicao) {       
        return http.post('/api/ajuste-parcial/resolver-pendencia-novo', requisicao);
    }

    resolverPendenciaAjusteParcialAlterar(requisicao) {       
        return http.post('/api/ajuste-parcial/resolver-pendencia-alterar', requisicao);
    }

    resolverPendenciaAjusteParcialExcluir(requisicao) {       
        return http.post('/api/ajuste-parcial/resolver-pendencia-excluir', requisicao);
    }

    buscarItensSolicitacaoMarcacoesEditadas(requisicao) {
        return http.post('/api/edicao-marcacoes/buscar-itens-solicitacao', requisicao); 
    }

    resolverEditarMarcacoesAlterarPendente(requisicao) {       
        return http.post('/api/edicao-marcacoes/resolver-pendencia-alterar', requisicao);
    }
}